import React, {useState} from 'react';

export default function YouTubeManager({items = [], onAdd, onRemove, onOrder}) {
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    const run = async action => {
        setBusy(true);
        setError('');
        try {
            await action();
        } catch (nextError) {
            setError(nextError.message);
        } finally {
            setBusy(false);
        }
    };
    const move = (index, direction) => {
        const target = index + direction;
        if (target < 0 || target >= items.length) return;
        const next = [...items];
        [next[index], next[target]] = [next[target], next[index]];
        run(() => onOrder(next.map(item => item.uuid)));
    };

    return <section className="content-editor-panel" aria-labelledby="youtube-title">
        <h2 id="youtube-title">YouTube videos</h2>
        <div className="content-youtube-add">
            <label htmlFor="youtube-url">YouTube URL</label>
            <input id="youtube-url" value={url} onChange={event => setUrl(event.target.value)} />
            <label htmlFor="youtube-title-input">Accessible title</label>
            <input id="youtube-title-input" value={title}
                onChange={event => setTitle(event.target.value)} />
            <button type="button" className="button" disabled={busy || !url.trim()}
                onClick={() => run(async () => {
                    await onAdd({url, title});
                    setUrl('');
                    setTitle('');
                })}>Add video</button>
        </div>
        {error && <p className="flash error" role="alert">{error}</p>}
        <ol className="content-media-list content-youtube-list">
            {items.map((item, index) => <li key={item.uuid}>
                <div><strong>{item.title || 'YouTube video'}</strong><small>{item.videoId}</small></div>
                <div className="content-media-actions">
                    <button type="button" className="button small" disabled={busy || index === 0}
                        onClick={() => move(index, -1)}>Up</button>
                    <button type="button" className="button small"
                        disabled={busy || index === items.length - 1}
                        onClick={() => move(index, 1)}>Down</button>
                    <button type="button" className="button small danger" disabled={busy}
                        onClick={() => run(() => onRemove(item.uuid))}>Remove</button>
                </div>
            </li>)}
        </ol>
    </section>;
}
